import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { Viewable } from "by/gamefactory/scene/viewable/Viewable";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { PiggyInfoPopupView } from "./view/PiggyInfoPopupView";
import { AsyncOperationNotification } from "../../common/components/AsyncOperationNotification";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { PiggyInfoResourcePackage } from "./resources/PiggyInfoResourcePackage";
import { PiggyInfoType } from "./components/PiggyInfoType";

@injectable()
export class PiggyInfoPopupScene extends Viewable<void> {
    private readonly canvasScaler: ICanvasScaler;
    private readonly logger: ILogger;
    private readonly commonResources: CommonResourcesPackage;
    private readonly type: PiggyInfoType;
    private readonly asyncOperationNotification: AsyncOperationNotification;
    private piggyResources: PiggyInfoResourcePackage;

    public constructor(
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("ILogger") logger: ILogger,
        commonResources: CommonResourcesPackage,
        type: PiggyInfoType,
        asyncOperationNotification: AsyncOperationNotification
    ) {
        super();
        this.canvasScaler = canvasScaler;
        this.logger = logger;
        this.commonResources = commonResources;
        this.type = type;
        this.asyncOperationNotification=asyncOperationNotification;
    }

    @initializer()
    public async initialization(): Promise<void> {
        try {
            this.asyncOperationNotification.show();
            this.piggyResources = new PiggyInfoResourcePackage();
            await this.piggyResources.load();
            this.asyncOperationNotification.hide();
            const viewCS = new PromiseCompletionSource<void>();
            this.view = new PiggyInfoPopupView(
                viewCS,
                this.canvasScaler,
                this.commonResources,
                this.piggyResources,
                this.type
            );
            viewCS.result.then(() => {
                this.piggyResources.destroy();
                this.operationControls.complete();
            }, (reason: any) => {
                this.logger.error(reason);
                throw reason;
            });
        } catch (error: unknown) {
            this.piggyResources.destroy();
            this.logger.error(error);
            this.operationControls.complete();
        }
    }
}
